import RestApiModel from "@/api/Model/RestApiModel";

class FacilityType extends RestApiModel {
  static getResourceEndpoint() {
    return '/facility-types';
  }
}

export default FacilityType;
